import {roundByEpsilon} from 'src/app/shared/utils/math.utils';

export class CashTransaction {
  private constructor(
    public readonly total: number,
    public readonly delivered: number = 0
  ) {}

  get change(): number {
    return roundByEpsilon(this.delivered - this.total);
  }

  get isValid(): boolean {
    return this.delivered >= this.total;
  }

  static create(total: number, delivered: number = 0): CashTransaction {
    return new CashTransaction(roundByEpsilon(total), roundByEpsilon(delivered));
  }
}
